import React, {Component} from 'react';
import ParentCode from '../../../../../components/admin/type/code/parentCode';
import ChildrenCode from '../../../../../components/admin/type/code/childrenCode';
import * as func from "../../../../../utils/functions";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import * as Actions from "../../../../../store/modules/code";
import {PropTypes} from "prop-types";
import {getParams} from "../../../../../utils/functions";

class Code extends Component {
	constructor(props) {
		super(props);
	}

	componentDidMount() {
		if (location.search.substring(1)) {
			this.props.dataActions.setCode({'param': func.parseParams(location.search.substring(1))});
		}
		// 이해 안됨.
		setTimeout(() => {
			this.getList();
		}, 0);
	}

	getList() {
		func.getData("code/search", this.props.param).then((response) => {
			response.parentRecords = response.records;
			delete response.records;
			this.props.dataActions.setCode(response);

			if(response.parentRecords.length > 0) {
				if(response.parentRecords[0].code_id) {
					const code_id = getParams('code') ? getParams('code') : response.parentRecords[0].code_id;
					func.getData("code/search/" + code_id, {}).then((response) => {
						response.childRecords = response.records;
						delete response.records;
						response.selectChildCodeId = code_id;
						this.props.dataActions.setCode(response);
					});
				}
			}
		});
	}

	render() {
		return (
			<>
				<div className="row mt-4 mb-2">
					<div className="col-md-12 form-group">
						<h6>코드</h6>
						<div className="row">
							<div className="col-md-5">
								<ParentCode/>
							</div>
							<div className="col-md-7">
								<ChildrenCode/>
							</div>
						</div>
					</div>
				</div>
			</>
		)
	}
}

// export default Code;

export default connect(
	(state) => ({
		param: state.code.param ? state.code.param : {},
		records: state.code.records ? state.code.records : [],
		// record: state.code.records ? state.code.records : {},
		// facet: state.code.facet ? state.code.facet : {},
		// totalRecords: state.code.totalRecords ? state.code.totalRecords : 0,
		// totalPage: state.code.totalPage ? state.code.totalPage : 0,
		// isPopup1: state.code.isPopup1 ? state.code.isPopup1 : 0,
	}),
	(dispatch) => ({
		dataActions: bindActionCreators(Actions, dispatch)
	}),
)(Code)

Code.propTypes = {
	param: PropTypes.object,
	records: PropTypes.array,
	// facet: PropTypes.object,
	// totalRecords: PropTypes.number,
	// totalPage: PropTypes.number,
};
